<template>
  <div>
    <Form :create="true" :description-title="'Adicione um novo evento'">
      <CreateButton
        @click="registerEvent()"
        :icon="PhCloudCheck"
        :label="'Registrar'"
      />
    </Form>
  </div>
</template>

<script setup>
import CreateButton from '@/components/Buttons/Create.vue'
import Form from '../components/RegisterForm.vue'
import {
  cleanAllFormFields,
  setFormFieldsError,
  validateFormField
} from '@/helpers/formFieldsHandler'
import { showToast as toast } from '@/helpers/UseToasts'
import { dataEvent } from '../store'
import { storeApp } from '@/store'
import { onBeforeMount } from 'vue'
import * as yup from '@/validator'
import { PhCloudCheck } from '@phosphor-icons/vue'
import EventService from '../service/event.service'

const store = dataEvent.state
const appStore = storeApp.state

const schema = yup.object().shape({
  events: yup.object().shape({
    title: yup.string().required('Informe um titulo').label('Titulo'),
    starts_at: yup.string().required('Informe o inicio do evento'),
    is_live: yup.string().required('Informe se é um evento ao vivo'),
    is_private: yup.string().required('Informe se o evento é privado'),
    requires_payment: yup.string().required('Informe se o evento é gratuito')
  })
})

const isFile = (value) => {
  return value instanceof File ||
    (typeof value === 'object' && value?.name)
}

const isStringNotEmpty = (value) => {
  return typeof value === 'string' && value.trim() !== '' && value !== '[]'
}

async function registerEvent () {
  appStore.loading = true

  cleanAllFormFields()
  const validate = (await validateFormField(schema, store))

  if (validate && validate.length > 0) {
    console.log(validate)
    toast(
      'Aviso',
      'Campos obrigatórios não preenchidos',
      'error'
    )
    setFormFieldsError(validate)
    appStore.loading = false
    return
  }

  // validaçãop do banner
  try {
    const banner = store.events?.banner
    const bannerName = store.events?.bannerName

    if (!isFile(banner) && isStringNotEmpty(bannerName)) {
      const res = await EventService.editImage(banner, bannerName)
      store.events.banner = res.data
      store.events.bannerName = res.data
    } else if (isFile(banner)) {
      const res = await EventService.saveImage(banner)
      store.events.banner = res.data
      store.events.bannerName = res.data
    } else if (isStringNotEmpty(bannerName)) {
      store.events.banner = bannerName
    } else {
      store.events.banner = ''
      store.events.bannerName = ''
    }
  } catch (err) {
    toast('Aviso', 'Falha no upload do arquivo.', 'error')
  }

  delete store.events?.id
  delete store.events?.bannerName
  
  let data = store
  
  if(data.events?.requires_payment == true)
    data.events.price = null
  
  await EventService.newEvent(data.events)
    .then(res => {
      if (res?.data?.success) {
        Promise.all([
          getEvents()
        ])

        toast(
          'Sucesso',
          res.data.message,
          'success'
        )

        dataEvent.dispatch('resetForm')
        appStore.loading = false
      }
    }).catch(err => {
      appStore.loading = false

      if (err?.response?.data?.error && err.response.data.status === 422) {
        return toast(
          'Aviso',
          'Verifique os campos e tente novamente',
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado ao registrar evento',
        'error'
      )
    })
}

async function getEvents () {
  await EventService.getEvents()
    .then((res) => {
      dataEvent.dispatch('setAllEvents', res.data)
    })
    .catch((err) => {
      console.log(err)
    })
}

onBeforeMount(async () => {
  appStore.loading = true
  dataEvent.dispatch('setBackComponent', 'SectorForm')
  appStore.loading = false
})
</script>
